/**
 * Action types for Basic Settings functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_BASIC_SETTINGS = 'GET_BASIC_SETTINGS';
export const GET_BASIC_SETTINGS_SUCCESS = 'GET_BASIC_SETTINGS_SUCCESS';
export const GET_BASIC_SETTINGS_FAIL = 'GET_BASIC_SETTINGS_FAIL';
export const EDIT_BASIC_SETTINGS = 'EDIT_BASIC_SETTINGS';
export const EDIT_BASIC_SETTINGS_SUCCESS =  'EDIT_BASIC_SETTINGS_SUCCESS';
export const EDIT_BASIC_SETTINGS_FAIL =  'EDIT_BASIC_SETTINGS_FAIL';